const SupportStatusTypes = {
    NEW: { id: 1, label: 'New' },
    WORKING: { id: 2, label: 'Working' },
    WAITING_ON_CUSTOMER: { id: 3, label: 'Waiting on Customer' },
    ESCALATED: { id: 4, label: 'Escalated' },
    CLOSED_COMPLETED: { id: 5, label: 'ClosedCompleted' },
    CLOSED_FORWARDED: { id: 6, label: 'ClosedForwarded' },
};

const SupportRequestTypes = [
    { id: 1, name: 'Payoff Request' },
    { id: 2, name: 'Lender Placed Insurance Inquiry' },
    { id: 3, name: 'Change in Billing Address or Email' },
    { id: 4, name: 'General Inquiry' },
    { id: 5, name: 'Invoice Inquiry' },
    { id: 6, name: 'Asset Location Change Request - Lease' },
    { id: 7, name: 'Title or Registration Inquiry' },
    { id: 8, name: 'Others' },
] as const;

export { SupportStatusTypes, SupportRequestTypes };
